import { render, staticRenderFns } from "./sup-how-to-login.vue?vue&type=template&id=5a0d4d50"
import script from "./sup-how-to-login.vue?vue&type=script&lang=js"
export * from "./sup-how-to-login.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports